<template>
  <div class="aqt_bottom">
    <ul class=" aqt_bottom_items">
      <router-link  to="/Personal" class="aqt_bottom_item">
        <img src="../assets/img/index11.png"/>
        <p class="footer_nav_title">关于我们</p>
      </router-link>
      <li class="aqt_bottom_item">
        <img src="../assets/img/index12.png"/>
        <p class="footer_nav_title">商业合作</p>
      </li>
      <li class="aqt_bottom_item">
        <a target="_blank" href="http://www.nudel.cn/">
          <img src="../assets/img/index13.png"/>
          <p class="footer_nav_title">游牧文化</p>
        </a>

      </li>

    </ul>
    <p class="dress">地址：内蒙古自治区呼和浩特市赛罕区乌兰察布东路街道博尔顿广场B座9层901、910</p>
    <p class="telephone">邮箱：1072913745@qq.com</p>
    <div class="national">
      <a target="_blank" href="http://www.beian.miit.gov.cn" class="national2_link">
      <img src="../assets/img/app.png" class="national_img"/>
      <p class="records">蒙ICP备16004441号-2</p>
      </a>
    </div>
    <div class="national2">
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15010502001000" class="national2_link">
        <img src="../assets/img/app1.png" class="national_img" alt=""/>
        <p class="records">蒙公网安备 15010502001000号</p>
      </a>
    </div>
    <div class="under_line"></div>
    <p class="copyright">2019内蒙古阿启泰科技有限公司版权所有</p>

  </div>
</template>

<script>
    export default {}
</script>

<style>

  .aqt_bottom{
    width: 100%;
    height: 16rem;
    background-color: #272D74;
    padding-top: 5%;
  }
  .aqt_bottom_items{
    width: 60%;
    height: 4rem;
    margin-left: 22%;
    display:flex;
    flex-direction:row;
    justify-content: space-between;
  }
  .aqt_bottom_items img {
    height: 2rem;
    margin-top: 0.2rem;
    margin-left: 0;
  }
  .aqt_bottom_item{
    text-align:center;
    font-size:0.7rem;
    color:#D3DFFF;
  }
  .footer_nav_title{
    text-align:center;
    font-size:0.7rem;
    color:#D3DFFF;
  }
  .dress, .telephone{
    color:#D3DFFF;
    font-size:0.8rem;
    margin-bottom:0.5rem;
    text-indent:4%;
  }
  .under_line{
    height: 0.1rem;
    background-color: #fff;
    /*margin-top: 2rem;*/
  }
  .copyright{
    color:#D3DFFF;
    font-size:0.8rem;
    padding-top:0.3rem;
    text-align:center;
  }
  .national{
    width:70%;
    height:auto;
    display:flex;
    flex-direction:row;
    margin-left:4%;
  }
   .national_img{
     width: 1rem;
     height:1rem;
   }
   .national2{
     width:70%;
     height:auto;
     margin-top: 0.5rem;
     margin-bottom: 5%;
     margin-left:4%;

   }
   .national2_link{
    display:inline-block;
     width:100%;
     height:auto;
     display:flex;
     flex-direction:row;
   }
  .records{
    margin-left:1%;
    color:#D3DFFF;
  }
</style>
